const meta = { requiresAuth: true };

const SuccessionPool = () => import(/* webpackChunkName: "succession-pool" */ '@/views/talent-management/succession-pool/Root');
const SuccessionPoolDetail = () => import(/* webpackChunkName: "succession-pool-detail" */ '@/views/talent-management/succession-pool/Detail');
const SuccessionPoolForm = () => import(/* webpackChunkName: "succession-pool-form" */ '@/views/talent-management/succession-pool/Form');
const SuccessionPoolIndex = () => import(/* webpackChunkName: "succession-pool" */ '@/views/talent-management/succession-pool/Index');
const SuccessionPoolEmployeeProfile = () => import(/* webpackChunkName: "succession-pool-employee-profile" */ '@/views/employee/Index');

const IndividualDevelopment = () => import(/* webpackChunkName: "individual-development" */ '@/views/talent-management/individual-development/Root');
const IndividualDevelopmentIndex = () =>
  import(/* webpackChunkName: "individual-development-index" */ '@/views/talent-management/individual-development/Index');
const IndividualDevelopmentForm = () =>
  import(/* webpackChunkName: "individual-development-form" */ '@/views/talent-management/individual-development/form/Index');
const IndividualDevelopmentDetail = () =>
  import(/* webpackChunkName: "individual-development-detail" */ '@/views/talent-management/individual-development/Detail');
const CompetenciesRoot = () => import(/* webpackChunkName: "competencies" */ '@/views/talent-management/competencies/Root');
const CompetencyAssignmentRoot = () =>
  import(/* webpackChunkName: "competency-assignment" */ '@/views/talent-management/competencies/assignment/Root');
const CompetencyAssignmentIndex = () =>
  import(/* webpackChunkName: "competency-assignment-index" */ '@/views/talent-management/competencies/assignment/Index');
const CompetencyAssignmentForm = () =>
  import(/* webpackChunkName: "competency-assignment-form" */ '@/views/talent-management/competencies/assignment/Form');
const CompetencySetupRoot = () => import(/* webpackChunkName: "competency-setup-root" */ '@/views/talent-management/competencies/setup/Root');
const CompetencyItemIndex = () =>
  import(/* webpackChunkName: "competency-item-index" */ '@/views/talent-management/competencies/setup/competency-item/Index');
const CompetencyItemUpload = () =>
  import(/* webpackChunkName: "competency-item-upload" */ '@/views/talent-management/competencies/setup/competency-item/Upload');
const CompetencyGroupIndex = () =>
  import(/* webpackChunkName: "competency-group-index" */ '@/views/talent-management/competencies/setup/competency-group/Index');
const CompetencyGroupForm = () =>
  import(/* webpackChunkName: "competency-group-form" */ '@/views/talent-management/competencies/setup/competency-group/Form');
const CompetencyRatingIndex = () =>
  import(/* webpackChunkName: "competency-rating-index" */ '@/views/talent-management/competencies/setup/rating-scale/Index');

const TalentManagementLanding = () => import(/* webpackChunkName: "talent-management-landing" */ '@/views/talent-management/landing/Index');
export default [
  {
    name: 'talent_management_landing',
    path: '/talent-management-landing',
    component: TalentManagementLanding,
    meta,
  },
  {
    path: '/succession-plan',
    component: SuccessionPool,
    meta,
    children: [
      {
        path: 'detail/:id',
        name: 'succession_plan_detail',
        component: SuccessionPoolDetail,
      },
      {
        path: '',
        name: 'sucession_plan',
        meta,
        redirect: 'key-position',
      },
      {
        path: 'profile/:name_slug',
        name: 'succession_plan_employee_profile',
        props: { uuid: '', name: '', avatar: '', job: '', key_position: '', succession_uuid: '', readiness: '' },
        component: SuccessionPoolEmployeeProfile,
      },
      {
        path: 'form',
        name: 'succession_plan_create',
        component: SuccessionPoolForm,
      },
      {
        path: 'form/:id?',
        name: 'succession_plan_edit',
        component: SuccessionPoolForm,
      },
      {
        path: ':tab',
        name: 'succession_plan_index',
        meta,
        component: SuccessionPoolIndex,
      },
    ],
  },
  {
    path: '/individual-development-plan',
    component: IndividualDevelopment,
    meta,
    children: [
      {
        path: '',
        name: 'individual_development_plan_index',
        meta,
        component: IndividualDevelopmentIndex,
      },
      {
        path: 'create',
        name: 'individual_development_plan_create',
        meta,
        component: IndividualDevelopmentForm,
      },
      {
        path: 'edit/:id',
        name: 'individual_development_plan_edit',
        meta,
        component: IndividualDevelopmentForm,
      },
      {
        path: 'detail/:uuid',
        name: 'individual_development_plan_detail',
        meta,
        component: IndividualDevelopmentDetail,
      },
    ],
  },
  {
    path: '/competency-management',
    component: CompetenciesRoot,
    meta,
    children: [
      {
        path: '',
        name: 'competency_index',
        redirect: 'assignment',
      },
      {
        path: 'assignment',
        name: 'competency_assignment',
        component: CompetencyAssignmentRoot,
        children: [
          {
            path: '',
            name: 'competency_assignment_index',
            component: CompetencyAssignmentIndex,
          },
          {
            path: 'form',
            name: 'competency_assignment_create',
            component: CompetencyAssignmentForm,
          },
          {
            path: 'form/:id?',
            name: 'competency_assignment_edit',
            component: CompetencyAssignmentForm,
          },
        ],
      },
      {
        path: 'setup',
        component: CompetencySetupRoot,
        children: [
          {
            path: '',
            name: 'competencies_setup_index',
            redirect: 'group',
          },
          {
            path: 'group',
            name: 'competency_group',
            component: CompetencySetupRoot,
            children: [
              {
                path: '',
                name: 'competency_group_index',
                component: CompetencyGroupIndex,
              },
              {
                path: 'form',
                name: 'competency_group_create',
                component: CompetencyGroupForm,
              },
              {
                path: 'form/:uuid?',
                name: 'competency_group_edit',
                component: CompetencyGroupForm,
              },
            ],
          },
          {
            path: 'item',
            name: 'competency_item',
            component: CompetencySetupRoot,
            children: [
              {
                path: '',
                name: 'competency_item_index',
                component: CompetencyItemIndex,
              },
              {
                path: 'upload',
                name: 'competency_item_upload',
                component: CompetencyItemUpload,
              },
              {
                path: 'bulk-edit',
                name: 'competency_item_bulk_edit',
                component: CompetencyItemUpload,
              },
            ],
          },
          {
            path: 'rating',
            name: 'competency_rating',
            component: CompetencySetupRoot,
            children: [
              {
                path: '',
                name: 'competency_rating_index',
                component: CompetencyRatingIndex,
              },
            ],
          },
        ],
      },
    ],
  },
];
